<template>
    <v-container>
      <simpleRoulette
      v-if="!this.$vuetify.breakpoint.smAndDown"
      v-bind:welcomeText = "welcomeText"
      v-bind:descText = "descText"
      v-bind:sideImg = "sideImg"
      v-bind:cards = "cards"
      ></simpleRoulette>
      <simpleRouletteMobile
      v-if="this.$vuetify.breakpoint.smAndDown"
      v-bind:welcomeText = "welcomeText"
      v-bind:descText = "descText"
      v-bind:sideImg = "sideImg"
      v-bind:cards = "cards"
      ></simpleRouletteMobile>
    </v-container>
  </template>

  <script>
      import simpleRoulette from '../../components/simpleRoulette';
      import simpleRouletteMobile from '../../components/simpleRouletteMobile';
  
      export default {
        name: 'simpleSissy',
        components: {
          simpleRoulette,
          simpleRouletteMobile,
        },
        data: () => ({
          welcomeText: "Welcome to Anal Domme Roulette",
          descText: "In this roulette, you will be given a bondage task as well as an anal task, how long you must do each, and a chance to cum at the end of it! If you roll chastity, complete the task and try again! No cumming this round!",
          sideImg: "https://i.imgur.com/sArshIL.jpg",
          cards:[
            {
              rollTitle: "Bondage",
              cumulative: true,
              items: [
                {
                  text: "Collar",
                  active: false
                },
                {
                  text: "Leash",
                  active: false
                },
                {
                  text: "Ball Gag",
                  active: false
                },
                {
                  text: "Nipple Clamps",
                  active: false
                },
                {
                  text: "Blindfold",
                  active: false
                },
                {
                  text: "Chastity",
                  active: false
                },
              ],
              rolled: false
            },
            {
              rollTitle: "Anal Task",
              cumulative: false,
              items: [
                {
                  text: "Tickle Your Asshole",
                  active: false
                },
                {
                  text: "Finger Your Asshole",
                  active: false
                },
                {
                  text: "Put the Tip In",
                  active: false
                },
                {
                  text: "Fuck Yourself",
                  active: false
                },
                {
                  text: "Ride the Dildo Halfway",
                  active: false
                },
                {
                  text: "Ride the Dildo Balls Deep",
                  active: false
                },
              ],
              rolled: false
            },
            {
              rollTitle: "Anal Time",
              cumulative: false,
              items: [
                {
                  text: "5 Minutes",
                  active: false
                },
                {
                  text: "10 Minutes",
                  active: false
                },
                {
                  text: "15 Minutes",
                  active: false
                },
                {
                  text: "30 Minutes",
                  active: false
                },
                {
                  text: "1 Hour",
                  active: false
                },
                {
                  text: "2 Hours",
                  active: false
                },
              ],
              rolled: false
            },
            {
              rollTitle: "Cum Permission",
              cumulative: false,
              items: [
                {
                  text: "No Cumming! Reroll!",
                  active: false
                },
                {
                  text: "Cum On A Dildo, Lick It",
                  active: false
                },
                {
                  text: "Cum On the Floor, Lick It",
                  active: false
                },
                {
                  text: "Cum On Your Face",
                  active: false
                },
                {
                  text: "Ruin Your Orgasm",
                  active: false
                },
                {
                  text: "Cum How You'd Like!",
                  active: false
                },
              ],
              rolled: false
            },
          ]
        }),
        methods: {
          roll() {
            this.cards.forEach(function(card) {
              card.rolled = true;
            })
          }
        },
      }
  </script>